var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulletInvestment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#1E2969",
    strokeWidth: 2,
    fill: "#F6C760",
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h30v30H10z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1E2969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.82 23.786h3.663c.725 0 1.313.587 1.313 1.313v6.03h-6.29V25.1c0-.726.587-1.313 1.313-1.313zM23.217 19.587h3.664c.725 0 1.313.587 1.313 1.313v10.23h-6.29V20.9c0-.726.588-1.313 1.313-1.313zM31.598 15.388h3.663c.726 0 1.314.587 1.314 1.313V31.13h-6.29V16.7c0-.725.587-1.312 1.313-1.312zM12.452 33.48c0-.432.345-.795.795-.795H36.85c.432 0 .795.345.795.795a.793.793 0 0 1-.795.795H13.247a.804.804 0 0 1-.795-.795z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulletInvestment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bullet-investment.b921f956c28f3bf4493e992d84d0ce1c.svg";